import _ from 'lodash';
import BaseCtrl from 'edge/platform/base/BaseCtrl';
import PropertyCodeUtil from 'edge/quoteandbind/common/util/PropertyCodeUtil';
import SessionUtil from 'edge/quoteandbind/common/util/SessionUtil';
import PropertyCodeViewDirective from 'edge/platform/widgets/typeahead/matchContentDirectives/PropertyCode/PropertyCode';
import ViewModelUtil from 'gw-portals-viewmodel-js/ViewModelUtil';
import $ from 'jquery';

var fn = function fn($scope, $state, $rootElement, StateUtils, $q, ViewModelService, ModalService, $stateParams, BOPCoverablesService, PropertyCodeLookupService, CoveragesUtil) {
    var ctrl = Object.create(BaseCtrl);
    var model = StateUtils.activeDataForState(true).model;

    var back = function back() {
        return $state.go($stateParams.initialPage, {
            buildingId: _.get($scope, 'building.publicID'),
            locationId: _.get($scope, 'location.publicID')
        });
    };

    ctrl.init = function () {
        $rootElement.scrollTop(0);

        $scope.transactionID = model.quoteID ? model.quoteID.value : model.jobID.value;
        $scope.additionalCoveragesOpen = { isOpen: false };
        $scope.saveButtonDisabled = false;
        $scope.updateBuildingCoverages = $q.resolve();

        $scope.dependentCoverages = CoveragesUtil.getDependentCoverages();
        var coveragesChanged = false;
        $scope.onCovChange = function (coverage) {
            coveragesChanged = true;
            return updateBuildingCoverages(coverage);
        };

        $scope.location = $stateParams.location;
        $scope.buildings = $stateParams.location.buildings;

        // Copy the building so that we don't edit it by reference. Necessary to handle back without save.
        $scope.building = _.extend({}, $stateParams.building || { classCode: '' });
        $scope.initialBuilding = _.cloneDeep($scope.building);
        $scope.existingBuilding = !_.isNull($stateParams.building);

        $scope.fakeLocationModel = {
            value: $scope.location.displayName,
            aspects: { valid: true }
        };

        var lookupCodesPromise = PropertyCodeLookupService.getPropertyCodes('BusinessOwners', $scope.transactionID, $scope.building.classCode || null, $scope.location.address, SessionUtil.getSessionUUID(model));

        $scope.classcodeLookup = {
            getMatches: function getMatches(userinput) {
                return lookupCodesPromise.then(function (propertyCodes) {
                    return _(propertyCodes).filter(function (code) {
                        return PropertyCodeUtil.toString(code).toLowerCase().includes((userinput || '').toLowerCase());
                    }).take(10).valueOf();
                }).catch(function () {
                    return ModalService.showError('ama.edge.quoteandbind.cpp.components.locationsAndBuildings.building.buildingCtrl.Error retrieving property class code', 'ama.edge.quoteandbind.cpp.components.locationsAndBuildings.building.buildingCtrl.Please check for errors and try again');
                });
            },
            toString: function toString(code) {
                if (ViewModelUtil.isViewModelNode(code)) {
                    return code.value;
                }

                return PropertyCodeUtil.toString(code);
            },
            directive: PropertyCodeViewDirective
        };

        var anAlarmTypeIsDefined = !!$scope.building.alarmType;

        $scope.hasAlarm = { // A fake viewmodel node to render a yes-no group
            value: anAlarmTypeIsDefined,
            aspects: {
                required: false,
                inputCtrlType: 'boolean',
                get valid() {
                    return true;
                }
            }
        };

        $scope.buildingView = ViewModelService.create($scope.building, 'pc', 'edge.capabilities.policyjob.lob.businessowners.coverables.dto.BuildingDTO');
        $scope.shouldShowCoverages = function () {
            // If own properties 1 level deep are valid — building form is valid.
            // Subtree check wouldn't work because it is also affected by particular coverages.
            var ownPropsValid = Object.keys($scope.buildingView).filter(function (prop) {
                return prop.charAt(0) !== '_';
            }).map(function (prop) {
                return $scope.buildingView[prop];
            }).every(function (VMNode) {
                return VMNode.aspects.valid;
            });

            return ownPropsValid && ($scope.existingBuilding || $scope.createBuildingOp);
        };

        var getBuildingToSave = function getBuildingToSave() {
            var newBuilding = validateAndSubstituteNumericInput($scope.buildingView.value);
            newBuilding.displayName = formatDisplayName(newBuilding);

            var doesNotHaveAlarm = !$scope.hasAlarm.value;
            if (doesNotHaveAlarm) {
                newBuilding.alarmType = undefined;
            }
            return newBuilding;
        };

        function validateAndSubstituteNumericInput(view) {
            ['yearBuilt', 'numberOfStories', 'totalAreaExcludingBasement'].forEach(function (key) {
                if (!view[key]) {
                    view[key] = null;
                }
            });
            return view;
        }

        if (!$scope.existingBuilding) {
            $scope.createBuildingOp = null;

            var unwatch = _.noop;
            $scope.createBuilding = function () {
                if (_.get($scope.buildingView, 'classCode.aspects.valid') && _.get($scope.buildingView, 'basisAmount.aspects.valid')) {
                    unwatch();

                    if (!getBuildingToSave().publicID) {
                        $scope.createBuildingOp = BOPCoverablesService.addBOPBuilding($scope.transactionID, $scope.location.publicID, getBuildingToSave(), SessionUtil.getSessionUUID(model)).then(function (result) {
                            _.extend($scope.buildingView.value, result);
                        }).catch(function () {
                            return ModalService.showError('ama.edge.quoteandbind.cpp.components.locationsAndBuildings.building.buildingCtrl.Building not saved', 'ama.edge.quoteandbind.cpp.components.locationsAndBuildings.building.buildingCtrl.Please check for errors and try again');
                        });
                    }
                }
            };
            unwatch = $scope.$watch('buildingView.classCode.value', $scope.createBuilding);

            var basisAmountElement = $('ng-form#newBuildingForm');
            basisAmountElement.on('focusout', 'gw-pl-input-ctrl#gw-basis-amount', $scope.createBuilding);
            $scope.$on('$destroy', function () {
                basisAmountElement.off('focusout', $scope.createBuilding);
            });
        }

        var sequencer = CoveragesUtil.getSequencer();
        var updateBuildingCoverages = function updateBuildingCoverages(coverage) {
            $scope.coveragesLoading = true;
            $scope.building = validateAndSubstituteNumericInput($scope.building);
            $scope.updateBuildingCoverages = sequencer(BOPCoverablesService.updateBOPBuildingCoverages($scope.transactionID, $scope.location.publicID, $scope.building, SessionUtil.getSessionUUID(model)));

            $scope.updateBuildingCoverages.then(function (result) {
                CoveragesUtil.updateCoverages(coverage, result.baseCoverages, $scope.building.baseCoverages);
                CoveragesUtil.updateCoverages(coverage, result.additionalCoverages, $scope.building.additionalCoverages);
            }).catch(function () {
                return ModalService.showError('ama.edge.quoteandbind.cpp.components.locationsAndBuildings.building.buildingCtrl.Building not saved', 'ama.edge.quoteandbind.cpp.components.locationsAndBuildings.building.buildingCtrl.Please check for errors and try again');
            }).finally(function () {
                $scope.coveragesLoading = false;
            });

            return $scope.updateBuildingCoverages;
        };

        var handleBack = function handleBack() {
            if ($scope.existingBuilding && $scope.updateBuildingCoverages) {
                // After coverages are changed on an existing building, changes need to be rolled back.
                // Only terms marked as 'Updated' would be reset by the backend.
                // At this point we don't know which terms were updated (updated prop gets overwritten on update),
                // so we need to all coverages and all their terms as updated on an initial building dto.
                var markUpdated = function markUpdated(coverages) {
                    return coverages.forEach(function (coverage) {
                        coverage.updated = true;
                        coverage.terms.forEach(function (term) {
                            term.updated = true;
                        });
                    });
                };
                markUpdated($scope.initialBuilding.baseCoverages);
                markUpdated($scope.initialBuilding.additionalCoverages);

                $scope.updateBuildingCoverages.then(function () {
                    return BOPCoverablesService.updateBOPBuildingCoverages($scope.transactionID, $scope.location.publicID, $scope.initialBuilding, SessionUtil.getSessionUUID(model));
                }).then(function (result) {
                    $stateParams.building.baseCoverages = result.baseCoverages;
                    $stateParams.building.additionalCoverages = result.additionalCoverages;
                    back();
                }).catch(function () {
                    return ModalService.showError('ama.edge.quoteandbind.cpp.components.locationsAndBuildings.building.buildingCtrl.Building not saved', 'ama.edge.quoteandbind.cpp.components.locationsAndBuildings.building.buildingCtrl.Please check for errors and try again');
                });
            } else if (!$scope.existingBuilding && $scope.createBuildingOp) {
                $scope.deleteBuildingOp = $scope.createBuildingOp.then(function () {
                    return BOPCoverablesService.removeBOPBuilding($scope.transactionID, $scope.location.publicID, $scope.buildingView.publicID.value, SessionUtil.getSessionUUID(model));
                }).then(back).catch(function () {
                    return ModalService.showError('ama.edge.quoteandbind.cpp.components.locationsAndBuildings.building.buildingCtrl.Building not removed', 'ama.edge.quoteandbind.cpp.components.locationsAndBuildings.building.buildingCtrl.Please check for errors and try again');
                });
            } else {
                back();
            }
        };
        $scope.back = function () {
            if (!coveragesChanged && $scope.newBuildingForm.$pristine) {
                return handleBack();
            }

            ModalService.showConfirm('ama.edge.quoteandbind.cpp.components.locationsAndBuildings.building.buildingCtrl.Information will be lost', 'ama.edge.quoteandbind.cpp.components.locationsAndBuildings.building.buildingCtrl.Do you want to discard changes made to the building or its coverages?').result.then(handleBack);
        };

        $scope.showBasisAmount = function () {
            if ($scope.building.classCode) {
                return $scope.buildingView.basisAmount.aspects.required;
            }
            return false;
        };

        $scope.saveBuilding = function () {
            $scope.saveButtonDisabled = true;
            $scope.updateBuildingCoverages.then(function () {
                if (!CoveragesUtil.validateForm($scope.newBuildingForm)) {
                    $scope.saveButtonDisabled = false;
                    return;
                }

                var building = getBuildingToSave();

                return updateBuildingCoverages().then(function () {
                    $scope.updateOp = BOPCoverablesService.updateBOPBuilding($scope.transactionID, $scope.location.publicID, building, SessionUtil.getSessionUUID(model)).then(function (result) {
                        _.extend(building, result);

                        if (!$scope.existingBuilding) {
                            // new building
                            $scope.buildings.push(building);
                        } else {
                            _.extend($stateParams.building, building);
                        }
                        back();
                    });
                });
            }).catch(function () {
                $scope.saveButtonDisabled = false;
                ModalService.showError('ama.edge.quoteandbind.cpp.components.locationsAndBuildings.building.buildingCtrl.Building not saved', 'ama.edge.quoteandbind.cpp.components.locationsAndBuildings.building.buildingCtrl.Please check for errors and try again');
            });
        };
    };

    function formatDisplayName(building) {
        return '' + building.description;
    }

    return ctrl.create($scope);
};

fn.$inject = ['$scope', '$state', '$rootElement', 'StateUtils', '$q', 'ViewModelService', 'ModalService', '$stateParams', 'qnb.bopCoverablesService', 'qnb.PropertyCodeLookupService', 'CoveragesUtil'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/quoteandbind/ama/cpp/components/locationsAndBuildings/building/buildingCtrl.js
// module id = 813
// module chunks = 0